import React from "react";
import { SITE } from "@/lib/site";

export default function About() {
  const items = [
    {
      no: "01",
      label: "Mission",
      title: "Safe drinking water, accessible to every household.",
      body: `Make clean, reliable water supply convenient — from urban apartments to growing neighborhoods across ${SITE.city}.`,
    },
    {
      no: "02",
      label: "Vision",
      title: "India's most trusted water distribution network.",
      body: "Build the country's most reliable last-mile delivery platform, powered by data, logistics and a unified digital experience.",
    },
    {
      no: "03",
      label: "Focus",
      title: "Technology. Scalability. Reliability.",
      body: "App-first ordering, smart routing and a dark store network designed to scale rapidly without losing quality.",
    },
  ];

  return (
    <section id="about" className="py-24 md:py-32 bg-white">
      <div className="container-x">
        <div className="grid lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-5">
            <div className="eyebrow">About Us</div>
            <h2 className="serif h-display mt-4 text-4xl sm:text-5xl lg:text-6xl text-[#0b1d2a]">
              A next-generation <br /> <span className="italic text-[#0369a1]">water supply network.</span>
            </h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7 text-slate-600 text-base sm:text-lg leading-relaxed">
            Wateriia India is a {SITE.city}-headquartered water supply chain company specializing in high-volume bottled water distribution — pairing efficient logistics with a powerful digital platform.
          </div>
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-px bg-sky-100 rounded-3xl overflow-hidden border border-sky-100">
          {items.map((it, i) => (
            <div
              key={i}
              data-testid={`about-pillar-${i}`}
              className="bg-white p-8 md:p-10 hover:bg-sky-50/40 transition-colors"
            >
              <div className="flex items-baseline justify-between">
                <span className="serif text-2xl text-[#0369a1]">{it.no}</span>
                <span className="eyebrow">— {it.label}</span>
              </div>
              <h3 className="serif h-display mt-6 text-2xl sm:text-3xl text-[#0b1d2a]">{it.title}</h3>
              <p className="mt-4 text-slate-600 leading-relaxed">{it.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
